import { SearchPopover } from '@wellesley/search'
import { TitleBlock } from '../../../common/components/ToolbarItem/TitleBlock'
import { Search } from 'lucide-react'
import { Button } from '@wellesley/ui'
import { useParams } from 'react-router-dom'
import { Tooltip } from '../../../common/components/Tooltip'

export const SearchItem = () => {
  const { groupname = '' } = useParams()

  return (
    <SearchPopover groupName={groupname}>
      <Button
        variant="none"
        size="none"
        className="w-full cursor-pointer p-none"
        type="button"
      >
        <Tooltip tooltipText="Search">
          <TitleBlock
            name="Search"
            Icon={Search}
            variant="square"
            id="search"
            isItemActive={false}
          />
        </Tooltip>
      </Button>
    </SearchPopover>
  )
}
